import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const payrollRoutes = [
  {
    path: routes.payroll.TypeOfHead,
    element: lazyLoadRoutes("payroll/typeOfHead/pages/TypeOfHead"),
  },
  {
    path: routes.payroll.EarningSalaryHead,
    element: lazyLoadRoutes("payroll/earningSalaryHead/EarningSalaryHead"),
  },
  {
    path: routes.payroll.EarningSalaryHeadAdd,
    element: lazyLoadRoutes("payroll/earningSalaryHead/EarningSalaryHeadAdd"),
  },
  {
    path: `${routes.payroll.EarningSalaryHeadAdd}/:id`,
    element: lazyLoadRoutes("payroll/earningSalaryHead/EarningSalaryHeadAdd"),
  },

  {
    path: `${routes.payroll.EarningSalaryHeadView}/:id`,
    element: lazyLoadRoutes("payroll/earningSalaryHead/EarningSalaryHeadView"),
  },
  {
    path: routes.payroll.DeductionHead,
    element: lazyLoadRoutes("payroll/deductionHead/DeductionHead"),
  },
  {
    path: routes.payroll.DeductionHeadAdd,
    element: lazyLoadRoutes("payroll/deductionHead/DeductionHeadAdd"),
  },
  {
    path: `${routes.payroll.DeductionHeadAdd}/:id`,
    element: lazyLoadRoutes("payroll/deductionHead/DeductionHeadAdd"),
  },
  {
    path: `${routes.payroll.DeductionHeadView}/:id`,
    element: lazyLoadRoutes("payroll/deductionHead/DeductionHeadView"),
  },
  {
    path: routes.payroll.OtherHead,
    element: lazyLoadRoutes("payroll/otherHead/OtherHead"),
  },
  {
    path: routes.payroll.OtherHeadAdd,
    element: lazyLoadRoutes("payroll/otherHead/OtherHeadAdd"),
  },
  {
    path: `${routes.payroll.OtherHeadAdd}/:id`,
    element: lazyLoadRoutes("payroll/otherHead/OtherHeadAdd"),
  },
  {
    path: `${routes.payroll.OtherHeadView}/:id`,
    element: lazyLoadRoutes("payroll/otherHead/OtherHeadView"),
  },
  {
    path: routes.payroll.GlCodeSetting,
    element: lazyLoadRoutes("payroll/pages/glCodeSetting"),
  },
  {
    path: routes.payroll.OverTime,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/overTimeCalculation/pages/OverTime"
    ),
  },
  {
    path: routes.payroll.UploadOtAttendance,
    element: lazyLoadRoutes("payroll/pages/overtime/uploadotAttandance"),
  },
  {
    path: routes.payroll.OverTimeTransferOt,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/overTimeCalculation/pages/transferOvertime"
    ),
  },
  {
    path: routes.payroll.LwfRuleSetting,
    element: lazyLoadRoutes("payroll/lwfRuleSetting/LwfRuleSetting"),
  },
  {
    path: routes.payroll.LwfRuleSettingAdd,
    element: lazyLoadRoutes("payroll/lwfRuleSetting/LwfRuleSettingAdd"),
  },
  {
    path: `${routes.payroll.LwfRuleSettingAdd}/:id`,
    element: lazyLoadRoutes("payroll/lwfRuleSetting/LwfRuleSettingAdd"),
  },
  {
    path: routes.payroll.UploadOtAttendance,
    element: lazyLoadRoutes("payroll/pages/uploadOt"),
  },
  {
    path: routes.payroll.ProcessAll,
    element: lazyLoadRoutes("payroll/pages/processAll"),
  },
  {
    path: routes.payroll.SummaryReport,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/overTimeCalculation/pages/summaryReport"
    ),
  },
  {
    path: routes.payroll.DetailsReport,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/overTimeCalculation/pages/detailsReport"
    ),
  },
  {
    path: routes.payroll.ProfessionalTax,
    element: lazyLoadRoutes("payroll/professionalTax/ProfessionalTax"),
  },
  {
    path: routes.payroll.ProfessionalTaxAdd,
    element: lazyLoadRoutes("payroll/professionalTax/ProfessionalTaxAdd"),
  },
  {
    path: `${routes.payroll.ProfessionalTaxEdit}/:id`,
    element: lazyLoadRoutes("payroll/professionalTax/ProfessionalTaxEdit"),
  },
  {
    path: routes.payroll.CtcComponentSetting,
    element: lazyLoadRoutes("payroll/ctc-component/CtcComponentSettings"),
  },
  {
    path: routes.payroll.CtcComponentSettingReport,
    element: lazyLoadRoutes("payroll/ctc-component/CtcComponentReport"),
  },
  {
    path: routes.payroll.CtcComponentSettingAdd,
    element: lazyLoadRoutes("payroll/ctc-component/CtcComponentSettingsAdd"),
  },
  {
    path: `${routes.payroll.CtcComponentSettingAdd}/:id`,
    element: lazyLoadRoutes("payroll/ctc-component/CtcComponentSettingsAdd"),
  },
  {
    path: `${routes.payroll.CtcComponentSettingView}/:id`,
    element: lazyLoadRoutes("payroll/ctc-component/CtcComponentSettingsView"),
  },

  {
    path: routes.payroll.LeaveEncashment,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/leaveEncashment/pages/LeaveEncashment"
    ),
  },
  {
    path: routes.payroll.LeaveEncashmentReport,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/leaveEncashment/pages/LeaveEncashmentReport"
    ),
  },
  {
    path: routes.payroll.LeaveEncashmentNotAddBtn,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/leaveEncashment/pages/LeaveEncashmentNotAddBtn"
    ),
  },
  {
    path: routes.payroll.AttandanceReport,
    element: lazyLoadRoutes(
      "payroll/pages/AttandanceProcess/attandanceProcess"
    ),
  },
  {
    path: routes.payroll.AttandanceReportView,
    element: lazyLoadRoutes(
      "payroll/pages/AttandanceProcess/attandanceProcessView"
    ),
  },
  {
    path: routes.payroll.SalaryStructure,
    element: lazyLoadRoutes("payroll/salaryStructure/SalaryStructure"),
  },
  {
    path: `${routes.payroll.SalaryStructureList}/:id`,
    element: lazyLoadRoutes("payroll/salaryStructure/SalaryStructureList"),
  },
  {
    path: `${routes.payroll.SalaryStructureAdd}/:id`,
    element: lazyLoadRoutes("payroll/salaryStructure/SalaryStructureAdd"),
  },
  {
    path: `${routes.payroll.SalaryStructureView}/:id`,
    element: lazyLoadRoutes("payroll/salaryStructure/SalaryStructureView"),
  },
  {
    path: routes.payroll.BonusCalculation,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/bonusCalculation/pages/BonusCalculation"
    ),
  },
  {
    path: routes.payroll.BonusCalculationProcess,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/bonusCalculation/pages/BonusCalculationProcess"
    ),
  },
  {
    path: routes.payroll.BonusCalculationSummary,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/bonusCalculation/pages/BonusCalulationReport"
    ),
  },
  {
    path: routes.payroll.BonusCalculationDetails,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/bonusCalculation/pages/BonusCalculationDetails"
    ),
  },
  {
    path: routes.payroll.LwpArrear,
    element: lazyLoadRoutes("payroll/pages/lwpArrear/lwpArrear"),
  },
  {
    path: `${routes.payroll.LwpArrearCalculation}`,
    element: lazyLoadRoutes("payroll/pages/lwpArrear/lwpArrearCalculation"),
  },
  {
    path: `${routes.payroll.LwpArrearCalculationEdit}/:id`,
    element: lazyLoadRoutes("payroll/pages/lwpArrear/lwpArrearCalculationEdit"),
  },
  {
    path: routes.payroll.OtherArrear,
    element: lazyLoadRoutes("payroll/pages/OtherArrear/otherArrear"),
  },
  {
    path: routes.payroll.OtherArrearCalculation,
    element: lazyLoadRoutes("payroll/pages/OtherArrear/otherArrearCalculation"),
  },
  {
    path: `${routes.payroll.OtherArrearCalculationEdit}/:id`,
    element: lazyLoadRoutes("payroll/pages/OtherArrear/otherArrearEdit"),
  },
  {
    path: routes.payroll.GrautityCalculation,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/gratutityCalculation/pages/grautityCalculation"
    ),
  },

  {
    path: routes.payroll.EmployeeIncrement,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/employeeIncrement/EmployeeIncrement"
    ),
  },
  {
    path: `${routes.payroll.EmployeeIncrementList}/:id`,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/employeeIncrement/EmployeeIncrementList"
    ),
  },
  {
    path: `${routes.payroll.EmployeeIncrementAdd}/:id`,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/employeeIncrement/EmployeeIncrementAdd"
    ),
  },
  {
    path: `${routes.payroll.EmployeeIncrementEdit}/:id`,
    element: lazyLoadRoutes(
      "payroll/additional-calculation/employeeIncrement/EmployeeIncrementEdit"
    ),
  },
  {
    path: `${routes.payroll.ArrearBaiseList}`,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/IncrementArrearMultipleList"
    ),
  },
  {
    path: `${routes.payroll.ArrearBaiseMoreThanOne}`,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/IncrementArrearMoreThanOne"
    ),
  },
  {
    path: `${routes.payroll.ArrearBaiseView}/:id`,
    element: lazyLoadRoutes(
      "payroll/monthly-calculation/pages/IncrementArrear/IncrementArrearMoreThanOneView"
    ),
  },
];
